import { Outlet, useLocation } from "react-router-dom";
import { useEffect, useRef } from "react";
import { Sidebar } from "@/components/Sidebar";
import { Topbar } from "@/components/Topbar";
import { ImpersonationBanner } from "@/components/ImpersonationBanner";
import api from "@/lib/api";

export function Layout() {
  const location = useLocation();
  const lastActivity = useRef(Date.now());

  // Heartbeat for live monitoring
  useEffect(() => {
    const onActivity = () => { lastActivity.current = Date.now(); };
    window.addEventListener("mousemove", onActivity);
    window.addEventListener("keydown", onActivity);
    window.addEventListener("click", onActivity);

    const beat = async () => {
      const idle = Date.now() - lastActivity.current > 60_000;
      try {
        await api.post("/heartbeat", {
          page: location.pathname,
          activity: idle ? "idle" : "active",
        });
      } catch { /* ignore */ }
    };
    beat();
    const t = setInterval(beat, 30_000);
    return () => {
      clearInterval(t);
      window.removeEventListener("mousemove", onActivity);
      window.removeEventListener("keydown", onActivity);
      window.removeEventListener("click", onActivity);
    };
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen bg-background text-foreground">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <ImpersonationBanner />
        <Topbar />
        <main className="flex-1 min-w-0">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
